import { storage } from "modules/storage";

const storageKey = (userId: string) => `readTextMessages:${userId}`;

export const readMessageIds = (userId: string): Set<string> => {
  const stored = storage.getItem(storageKey(userId));

  return new Set(stored ? stored.split(",") : []);
};

export const markMessageRead = (userId: string, messageId: string): void => {
  const ids = readMessageIds(userId);

  if (ids.has(messageId)) return;

  ids.add(messageId);
  storage.setItem(storageKey(userId), [...ids].join(","));
};
